import send from '../../utils/fetch'

const state = {
    geo: [],
    geosMap: [],

}

const actions = {
    async GET_GEOS({ commit }) {
        try {
            const {data} = await send(global.$url.geo.get, 'GET')
            commit('SET_GEOS', data.result)
            commit('SET_GEOS_MAP', data.result)
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async CREATE_GEOS({ dispatch }, geos) {
        try {
            const {data} = await send(global.$url.geo.create, 'POST', {data: geos})
            dispatch('GET_GEOS')
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async UPDATE_GEOS({ dispatch }, id) {
        try {
            const {data} = await send(global.$url.geo.update, 'PUT', {data: id})
            dispatch('GET_GEOS')
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}

const mutations = {
    SET_GEOS(state, data) {
        state.geo = data
    },

    SET_GEOS_MAP(state, data) {
        const unique = arr => Array.from(new Set(arr))

        state.geosMap = data.geos.map(item => {
            const languages = []
            const languageView = []
            const countries = Object.keys(item.mapping)

            countries.map(key => {
                languages.push(item.mapping[key])
                languageView.push(...item.mapping[key])
            })

            item.geo_name = item.name
            item.geo_id = item.id
            item.country = unique(countries)
            item.language = languages
            item.languageView = unique(languageView)
            item.countryLength = item.country.length
            item.languageLength = item.languageView.length

            return item
        })
    }
}

const getters = {
    geo: state => state.geo,
    geosMap: state => state.geosMap
}

export default {
    state,
    actions,
    mutations,
    getters
}
